// extracted by mini-css-extract-plugin
module.exports = {"rippleParent":"Ripple_rippleParent__1PiSG","rippleSpan":"Ripple_rippleSpan__1bzl1","ripple":"Ripple_ripple__19v1z","dummy":"Ripple_dummy__1BtVX"};